import React, { Component, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import ProductCard from "./../component/ProductCard";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import HeadingSkeleton from "./../component/HeadingSkeleton";
import $ from "jquery";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";

const productImg = require("./../assets/img/product1-min.png");
const productImg2 = require("./../assets/img/product2-min.png");
const wishlistImg = require("./../assets/img/wishlist-icon2.svg").default;
const cartImg = require("./../assets/img/cart-icon.svg").default;

const Products = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();

  const [products, setProducts] = useState();
  const [loading, setLoading] = useState(true);
  const [removeError, setRemoveError] = useState("");

  const fetchWishlists = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/wishlists`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setProducts(responseData.data);
      } else {
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleRemoveWishlist = async id => {
    console.log("Removing wishlist item with ID:", id);
    try {
      setRemoveError("");
      const response = await fetch(`${API_BASE_URL}frontend/wishlists/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setProducts(prevProducts =>
          (prevProducts || []).filter(item => Number(item?.id) !== Number(id) && Number(item?.wishlist_id) !== Number(id))
        );
      } else {
        setRemoveError(responseData?.msg || langJson?.somethingwentwrong || "Unable to remove wishlist item.");
      }
    } catch (error) {
      setRemoveError(langJson?.somethingwentwrong || "Unable to remove wishlist item.");
    }
  };

  useEffect(() => {
    $(".dropDiv").each(function () {
      $("h3", this).click(() => {
        $(".subSidebar").hide();
        $(this).find(".subSidebar").toggle();
      });
    });

    $(".filterBtn").click(() => {
      $(".sideBar").show();
    });

    $(".crossBtn").click(() => {
      $(".sideBar").hide();
    });

    fetchWishlists();
  }, []);

  return (
    <div>
      <Header />
      <style>{`body { background: #FFF; }`}</style>

      <div className="mainDiv">
        <div className="acctHdn">
          <div className="hdnSec topNew">
            {loading ? (
              <HeadingSkeleton width="220px" height="34px" />
            ) : (
              <h2 className="storeTabHdn">{langJson?.mywishlist}</h2>
            )}
            {removeError ? <span className="lgnStatus">{removeError}</span> : null}
          </div>

          <div className="wishlistDiv topNew tradePrdts">
            <div className="productList">
              <ul className="products new-products responsiveSliderGrid">
                {loading
                  ? Array.from({ length: 10 }).map((_, index) => (
                    <ProductCardSkeleton key={`wishlist-skeleton-${index}`} />
                  ))
                  : products?.length > 0
                    ? products?.map((product, index) => (
                      <ProductCard
                        key={product.id || product.wishlist_id || product.order_no || index}
                        product={product}
                        isWishlistView={true}
                        wishlistId={product.wishlist_id}
                        handleRemoveWishlist={handleRemoveWishlist}
                      />
                    ))
                    : langJson?.noitemsfound}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Products;
